import React from 'react';
import { useModel, useParams } from "bcms-react";

import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';
import ExternalIframe from 'components/shared/containers/ExternalIframe';

import "./styles.css";

export default function CH21Page(props) {
    const branding = useModel().branding.options;
    window.BRANDING = { "cards_abi22": branding.cards_abi22 };
    // In MABI23, CH21 is shown without an ABI22 container. 
    // It appears as a standalone app.
    const removeABI22Container = props.removeAB22IContainer ? props.removeAB22IContainer : false;

    return (
        <>
            { !removeABI22Container &&
            <PageContainer className="cardhub-mobile-page integrated-product-page" ignoreTrigger={ true }>
                <PageContentView>
                    <CenterContentContainer>
                        <ContentHeaderView text="Cards" />
                        <ExternalIframe demo="CH21" key ="CH21Page"/>
                    </CenterContentContainer>
                </PageContentView>
            </PageContainer>
            }
            { removeABI22Container && <ExternalIframe demo="CH21" className="cardhub-mobile-iframe" key ="CH21Page"/> }
        </>
    );
}